import type { DirectusErrorType } from '@/features/api/directus';
import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fakeBaseQuery<DirectusErrorType>(),
  endpoints: () => ({}),
});
